import { Color } from './color';
/**
 * ▶◀
 */
export const Bowtie = (options, context) => {
    return Color(Object.assign({ colorAttribute: 'fill', symbol: 'bowtie' }, options), context);
};
Bowtie.props = Object.assign({ defaultMarker: 'bowtie' }, Color.props);
//# sourceMappingURL=bowtie.js.map